import { useEffect, useState } from 'react';
import { request } from './OperationsProvider';

export default function useTripTrail(tripId, updatedAt) {
  const [state, setState] = useState({ tripId: null, items: [], total: 0, thinned: false, error: null });
  useEffect(() => {
    const controller = new AbortController();
    // Keep the current trail while the same trip refreshes, so the map line does not blink out
    // on every poll; only a different trip starts from an empty trail.
    setState((current) => (current.tripId === tripId ? current : { tripId, items: [], total: 0, thinned: false, error: null }));
    if (tripId) {
      request(`/api/operations/samples?tripId=${encodeURIComponent(tripId)}`, 'GET', null, controller.signal)
        .then((result) => {
          if (!controller.signal.aborted) setState({ tripId, ...result, error: null });
        })
        .catch((error) => {
          if (!controller.signal.aborted) setState((current) => ({ ...current, tripId, error: error.message }));
        });
    }
    return () => controller.abort();
  }, [tripId, updatedAt]);
  return state;
}
